import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Get auth headers
export const getAuthHeaders = () => {
  const token = localStorage.getItem('admin_token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

// Check if user is authenticated
export const isAuthenticated = () => {
  return !!localStorage.getItem('admin_token');
};

// Logout
export const logout = () => {
  localStorage.removeItem('admin_token');
};

// Products API
export const productAPI = {
  getAll: () => axios.get(`${BACKEND_URL}/api/products`),
  
  create: (formData) => axios.post(
    `${BACKEND_URL}/api/admin/products`,
    formData,
    {
      ...getAuthHeaders(),
      headers: {
        ...getAuthHeaders().headers,
        'Content-Type': 'multipart/form-data'
      }
    }
  ),
  
  update: (id, formData) => axios.put(
    `${BACKEND_URL}/api/admin/products/${id}`,
    formData,
    {
      ...getAuthHeaders(),
      headers: {
        ...getAuthHeaders().headers,
        'Content-Type': 'multipart/form-data'
      }
    }
  ),
  
  delete: (id) => axios.delete(
    `${BACKEND_URL}/api/admin/products/${id}`,
    getAuthHeaders()
  )
};

// Contact Messages API
export const contactAPI = {
  getAll: () => axios.get(
    `${BACKEND_URL}/api/admin/contact-messages`,
    getAuthHeaders()
  ),
  
  markAsRead: (id) => axios.patch(
    `${BACKEND_URL}/api/admin/contact-messages/${id}/read`,
    {},
    getAuthHeaders()
  ),
  
  delete: (id) => axios.delete(
    `${BACKEND_URL}/api/admin/contact-messages/${id}`,
    getAuthHeaders()
  )
};
